import DuplicateShopItem from '../../../Domain/DuplicateShopItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ApolloShopCopierService from '../../../Services/ApolloShopCopierService';

// Task-style "Duplicate Apollo Shop" wizard. No entityName so the plain title wins.
// waitForServiceFunction returns false so the wizard fires the request without waiting
// (fire-and-forget) and shows messageOnSuccess immediately, matching the old panel's
// waitForResponseOnSubmit = false behavior (the backend reports the result via the user's
// notification repository).
export default class DuplicateShopWindowDescription {
  static titleForCreate = 'Duplicate Apollo Shop';
  static titleForEdit = 'Duplicate Apollo Shop';
  static itemType = DuplicateShopItem;
  static serviceFunction = ApolloShopCopierService.DuplicateShop;
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The duplication process has started. You will receive a message about the result in your personal notification repository. Please, be patient, the process may be slow depending on the number of pictures in the shop. Please do not edit the shop in Apollo before the process is fully completed!';
  static finishButtonLabel = 'Duplicate Shop';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Id',
          label: 'Apollo Sassie Id of the Original Shop',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ShopperId',
          label: 'Shopper Id (empty means 1223278)',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.AlwaysFlawless,
          roleKey: 'justForAdmins',
        },
        {
          fieldName: 'Status',
          label: 'Status (empty means 7)',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
